import { useQSet } from '@exam-management/common/qset-provider';
import { Grid, Text } from '@shared/components';

import {
  formatExamQuestionType,
  formatQuestionCalculationTags,
  formatQuestionDifficultyTags,
} from '../../utils';

export default function ExamInformation() {
  const { qSet } = useQSet();

  const { code, qConfig, conditions } = qSet;
  const pAvgValue = conditions?.averagePValue;
  const { examCourse, fullScore, totalQuestions } = qConfig;
  const { tags, questionTypes } = conditions ?? {};

  return (
    <Grid
      sx={(theme) => ({
        gridTemplateColumns: '160px 1fr',
        gap: theme.spacing(4, 6),
        '.MuiTypography-root:nth-of-type(even)': {
          wordBreak: 'break-word',
        },
      })}
    >
      <Text variant='body1Semibold'>QSet ID</Text>
      <Text variant='body1'>{code}</Text>

      <Text variant='body1Semibold'>หลักสูตรทดสอบ</Text>
      <Text variant='body1'>{examCourse.name}</Text>

      <Text variant='body1Semibold'>จำนวนข้อสอบทั้งหมด</Text>
      <Text variant='body1'>{totalQuestions} ข้อ</Text>

      <Text variant='body1Semibold'>คะแนนรวม</Text>
      <Text variant='body1'>{fullScore} คะแนน</Text>

      <Text variant='body1Semibold'>ประเภทคำถาม</Text>
      <Text variant='body1'>{questionTypes ? formatExamQuestionType(questionTypes) : '-'}</Text>

      <Text variant='body1Semibold'>ประเภทข้อสอบ</Text>
      <Text variant='body1'>{tags ? formatQuestionCalculationTags(tags) : '-'}</Text>

      <Text variant='body1Semibold'>ระดับความยาก</Text>
      <Text variant='body1'>{tags ? formatQuestionDifficultyTags(tags) : '-'}</Text>

      <Text variant='body1Semibold'>ค่า P Average</Text>
      <Text variant='body1'>{pAvgValue ? pAvgValue.toFixed(2) : '-'}</Text>
    </Grid>
  );
}
